import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Env from "Consts/env";

const baseQuery = fetchBaseQuery({
	baseUrl: process.env.NEXT_PUBLIC_ROOT_DOMAIN,
	headers: {
		...Env.HEADERS,
	},
});

export const apiSlice = createApi({
	baseQuery,
	endpoints: () => ({
	}),
	tagTypes: [
		"Products",
		"WishListProduct",
		"Flashsale",
		"UserWishlistProduct",
		"ListFlashsale",
		"Badges",
		"Search",
		"Home",
		"PopupCategory",
		// "ProductsList",
		"CART_ITEM",
		"CART_TOTAL",
		"ProductsList",
		"Address",
		"PaymentMethod",
		"Promo",
		"CartItem",
		"CartTotal",
		"PROVINCE",
		"REGION",
		"SEARCH_RESULT_PRODUCT",
		"SEARCH_RESULT_BRAND",
		"SEARCH_RESULT_PRODUCT_RECOMEND",
	],
	keepUnusedDataFor: 1800,
});

export const {
	endpoints, reducerPath, reducer, middleware,
} = apiSlice;
